const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"email":({"email_address":"E-mailadresse"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;